<template>
  <div class="monthYearPicker">
    <select
      placeholder="YYYY"
      @change="setMonth"
      :value="month === null ? '' : month"
      class="bg-transparent"
    >
      <option value="" selected>MM</option>
      <option
        v-for="option in months"
        :key="option.value"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
    <select
      placeholder="YYYY"
      @change="setYear"
      :value="year || ''"
      class="bg-transparent"
    >
      <option value="" selected>YYYY</option>
      <option
        v-for="option in years"
        :key="option.value || 'null'"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
    <button
      v-if="hasDateSelected"
      @click="resetDate"
      type="button"
      class="reset-button"
    >
      Reset
    </button>
    <label v-if="hasCurrentOption" class="flex flex-row space-x-2 flex-nowrap">
      <input @change="setCurrent" :checked="isCurrent" type="checkbox" />
      <span>Current</span>
    </label>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent, computed } from 'vue'
import useClickAway from '@/composables/useClickAway'
export default defineComponent({
  name: 'MonthYearPicker',
  props: {
    hasCurrentOption: {
      type: Boolean,
      default: false,
    },
    year: {
      type: Number as PropType<number>,
    },
    month: {
      type: Number as PropType<number>,
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
    futureYears: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    useClickAway('.monthYearPicker', () => {
      emit('close')
    })

    const hasDateSelected = computed(() => {
      return props.month !== null || props.year !== null
    })

    const setMonth = (e: Event) => {
      const month = parseInt((e.target as HTMLInputElement).value)
      emit('monthChange', month)
    }

    const setYear = (e: Event) => {
      const year = parseInt((e.target as HTMLInputElement).value)
      emit('yearChange', year)
    }

    const setCurrent = (e: Event) => {
      const isCurrent = (e.target as HTMLInputElement).checked
      setTimeout(() => emit('currentChange', isCurrent), 100)
    }

    const resetDate = () => {
      emit('reset')
    }

    const months = [
      { text: 'January', value: 0 },
      { text: 'February', value: 1 },
      { text: 'March', value: 2 },
      { text: 'April', value: 3 },
      { text: 'May', value: 4 },
      { text: 'June', value: 5 },
      { text: 'July', value: 6 },
      { text: 'August', value: 7 },
      { text: 'September', value: 8 },
      { text: 'October', value: 9 },
      { text: 'November', value: 10 },
      { text: 'December', value: 11 },
    ]

    const years = (() => {
      let currentYear = new Date().getFullYear() + props.futureYears
      return [...Array(75).keys()].map(() => ({
        text: currentYear,
        value: currentYear--,
      }))
    })()

    return {
      months,
      years,
      setMonth,
      setYear,
      setCurrent,
      hasDateSelected,
      resetDate,
    }
  },
})
</script>

<style lang="postcss" scoped>
.monthYearPicker {
  @apply absolute z-50 p-3 text-sm translate-y-full rounded shadow bg-jsNeutral-20 -bottom-2 flex flex-row items-center space-x-2 flex-nowrap;
  label > span {
    @apply text-sm font-normal;
  }
}

.reset-button {
  @apply text-sm text-primary cursor-pointer hover:underline;
}
</style>
